import { useEffect } from 'react';
import { Box } from '@mui/material';

export function unload() {
  const placeholder = document.getElementById('placeholder');

  if (placeholder) {
    placeholder.style.opacity = '0';
    placeholder.addEventListener('transitionend', () => placeholder.remove());
  }
}

export function Placeholder() {
  useEffect(() => () => unload());
  return <Box id="placeholder" />;
}
